// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

// TODO: Replace with fc-ng-tag component
@Component({
  selector: 'fc-status-tag',
  template: `
    <div
      [style.background-color]="backgroundColor"
      [class.outline]="outline"
      class="status-container"
    >
      <ng-content></ng-content>
      @if (!!text) {
        <div
          [style.color]="color"
          class="status-text"
          [ngClass]="textSizeClass"
        >
          {{ text }}
        </div>
      }
      @if (!!subtitle) {
        <div [style.color]="subtitleColor || color" class="status-subtitle">
          {{ subtitle }}
        </div>
      }
    </div>
  `,
  styles: [
    `
      @use 'var' as *;
      @use 'typography' as *;

      :host {
        display: flex;
        flex-direction: row;
      }

      .status-container {
        display: inline-flex;
        align-items: center;
        padding: 4px 8px;
        border-radius: 4px;
        gap: 6px;

        &.outline {
          border: 1px solid $grey-100;

          .status-text,
          .second-table {
            color: $grey-100 !important;
          }
        }
      }

      .status-text,
      .status-subtitle {
        font-weight: 500;
        font-size: 14px;
        &.small {
          @extend .label;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class StatusTagComponent {
  @Input() outline = false;
  @Input() text: string;
  @Input() subtitle: string;
  @Input() subtitleColor: string;
  @Input() color: string;
  @Input() textSize: 'medium' | 'small' = 'medium';

  get textSizeClass(): string {
    return this.textSize === 'medium' ? 'medium' : 'small';
  }

  get backgroundColor() {
    return this.outline
      ? 'transparent'
      : this.getTransparentColor(this.color, 0.1);
  }

  getTransparentColor(hex: string, opacity: number) {
    if (this.outline || !hex) return;
    const rgb = hex.match(/^#?(.{2})(.{2})(.{2})$/);
    return `rgba(${parseInt(rgb[1], 16)}, ${parseInt(rgb[2], 16)}, ${parseInt(
      rgb[3],
      16,
    )}, ${opacity})`;
  }
}
